<div class="date-picker-container" [ngClass]="config?.classes">
  <label *ngIf="config?.label" class="date-picker-label">{{ config.label | translate }}</label>

  <mat-form-field class="date-picker-field datePicker">
    <input matInput [matDatepicker]="picker" [value]="config?.value" [placeholder]="config?.placeholder"
      [disabled]="config?.disabled" [tabIndex]="config?.tabIndex" [min]="config?.minDate" [max]="config?.maxDate"
      [matDatepickerFilter]="isDateEnabled" (dateChange)="onDateChange($event)" readonly hidden>
    <button (click)="picker.open()" type="button" class="icon-btn">
      <span>{{ config?.value | date: 'shortDate' }}</span>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    </button>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <div *ngIf="currentErrorMessage" class="date-picker-error">
    {{ currentErrorMessage }}
  </div>
</div>